// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EstateLabel_wrapper__2RH46","logo":"EstateLabel_logo__2Te0m","builder":"EstateLabel_builder__3u1Bs"};